import { render, staticRenderFns } from "./VehicleEditor.vue?vue&type=template&id=f8c804e8"
import script from "./VehicleEditor.vue?vue&type=script&lang=ts"
export * from "./VehicleEditor.vue?vue&type=script&lang=ts"
import style0 from "./VehicleEditor.vue?vue&type=style&index=0&id=f8c804e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports